export default "/_next/static/assets/images/sporttip/sporttip-live-logo.fa6f197205ccb7d2a9d26f00aff8c98e.svg";